import { render, staticRenderFns } from "./RouteSidebarItem.vue?vue&type=template&id=1dfcb012&lang=html&"
import script from "./RouteSidebarItem.vue?vue&type=script&lang=js&"
export * from "./RouteSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports